import { render, staticRenderFns } from "./FilesTrash.vue?vue&type=template&id=4538fe14&scoped=true&"
import script from "./FilesTrash.vue?vue&type=script&lang=js&"
export * from "./FilesTrash.vue?vue&type=script&lang=js&"
import style0 from "./FilesTrash.vue?vue&type=style&index=0&id=4538fe14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4538fe14",
  null
  
)

export default component.exports